import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static values = { interval: Number }

  connect() {
    const ms = this.intervalValue || 10000
    this.timer = setInterval(() => {
      Turbo.visit(window.location.href, { action: "replace" })
    }, ms)
  }

  disconnect() {
    clearInterval(this.timer)
  }
}
